import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const CustomPrimeNgPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '#5da0ff',
      500: '#1e6fff',
      600: '#1a60e0',
      700: '#1552c0',
      800: '#0e3d90',
      900: '#092b68',
      950: '#051940'
    },
    colorScheme: {
      light: {
        surface: {
          0:   '#ffffff',
          50:  '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617'
        }
      },
      dark: {
        surface: {
          0:   '#ffffff',
          50:  '#1c2230',
          100: '#1c2230',
          200: '#2a3445',
          300: '#3a4a5e',
          400: '#7d8590',
          500: '#7d8590',
          600: '#c8d3de',
          700: '#e6edf3',
          800: '#e6edf3',
          900: '#e6edf3',
          950: '#e6edf3'
        }
      }
    }
  }
});
